import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewDocumentIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99989 3.50068C5.31255 3.45535 2.53322 5.33335 0.785885 7.25668C0.602474 7.4603 0.500977 7.72464 0.500977 7.99868C0.500977 8.27273 0.602474 8.53706 0.785885 8.74068C2.49522 10.6233 5.26655 12.5447 7.99989 12.4987C10.7332 12.5447 13.5052 10.6233 15.2159 8.74068C15.3993 8.53706 15.5008 8.27273 15.5008 7.99868C15.5008 7.72464 15.3993 7.4603 15.2159 7.25668C13.4666 5.33335 10.6872 3.45535 7.99989 3.50068Z",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 8C10.4999 8.49442 10.3531 8.9777 10.0784 9.38874C9.80357 9.79977 9.41307 10.1201 8.95625 10.3092C8.49942 10.4983 7.99678 10.5477 7.51187 10.4512C7.02696 10.3547 6.58156 10.1165 6.232 9.76686C5.88243 9.4172 5.6444 8.97174 5.54799 8.48681C5.45158 8.00188 5.50113 7.49924 5.69037 7.04247C5.8796 6.58569 6.20004 6.19528 6.61114 5.92061C7.02225 5.64593 7.50558 5.49933 8 5.49933C8.32839 5.49924 8.65357 5.56387 8.95697 5.68952C9.26036 5.81516 9.53603 5.99937 9.7682 6.2316C10.0004 6.46384 10.1845 6.73955 10.3101 7.04298C10.4356 7.34641 10.5002 7.67161 10.5 8Z",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgViewDocumentIcon);
export default ForwardRef;
